import { render, staticRenderFns } from "./ShopsTable.vue?vue&type=template&id=f2dca32c&"
import script from "./ShopsTable.vue?vue&type=script&lang=js&"
export * from "./ShopsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports